import styled from 'styled-components';

export const DateRangePickerContainer = styled.div`
  .rdrStartEdge {
    background-color: #1b7ff1 !important; /* Blue background for start date */
    color: white !important; /* White text for start date */
    border-radius: 8px !important; /* Rounded edges */

    .rdrDayNumber span {
      color: white !important; /* White text for start date */
    }
  }

  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span {
    color: white !important; /* White text for start date */
  }

  /* End date pill */
  .rdrEndEdge {
    background-color: #1b7ff1 !important; /* Blue background for end date */
    color: white !important; /* White text for end date */
    border-radius: 8px !important; /* Rounded edges */

    .rdrDayNumber span {
      color: white !important; /* White text for end date */
    }
  }

  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span {
    color: white !important; /* White text for end date */
  }

  /* Range selection (dates between start and end) */
  .rdrInRange {
    background-color: #e5f2ff !important; /* Light blue background for range */
    color: black !important; /* Black text for range dates */
  }

  /* Normal calendar date text (unselected) */
  .rdrDayNumber span {
    color: black !important; /* Default black text for unselected dates */
  }

  /* Text for start and end dates (inside the pills) */
  .rdrStartEdge span,
  .rdrEndEdge span {
    color: white !important; /* Ens */
  }

  .rdrMonthAndYearPickers select {
    color: var(--Theme-2-Theme-2-950, #09305a);
    font-family: Mulish;
    font-size: 18px;
    font-style: normal;
    font-weight: 800;
    line-height: 150%; /* 27px */
  }

  .rdrDayPassive {
    visibility: hidden;
  }
`;
